import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1185.47059,-0.0112941176 L1185.47059,564.694588 L1750.17647,564.694588 L1750.17647,1919.98871 L169,1919.98871 L169,-0.0112941176 L1185.47059,-0.0112941176 Z M1298.41176,1355.28282 L507.823529,1355.28282 L507.823529,1468.33694 L1298.41176,1468.33694 L1298.41176,1355.28282 Z M1185.47059,1129.40047 L507.823529,1129.40047 L507.823529,1242.34165 L1185.47059,1242.34165 L1185.47059,1129.40047 Z M1411.35294,903.518118 L507.823529,903.518118 L507.823529,1016.45929 L1411.35294,1016.45929 L1411.35294,903.518118 Z M959.701176,338.812235 L507.823529,338.812235 L507.823529,790.689882 L959.701176,790.689882 L959.701176,338.812235 Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M620.764706 677.647059L846.647059 677.647059 846.647059 451.764706 620.764706 451.764706zM1298.40047 451.809882L1733.33694 451.809882 1298.40047 16.8734118z"
}));

var IconMsWordSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconMsWordSolid, _Component);

  var _super = _createSuper(IconMsWordSolid);

  function IconMsWordSolid() {
    _classCallCheck(this, IconMsWordSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconMsWordSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconMsWord",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconMsWordSolid.displayName = "IconMsWordSolid";
  return IconMsWordSolid;
}(Component);

IconMsWordSolid.glyphName = 'ms-word';
IconMsWordSolid.variant = 'Solid';
IconMsWordSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconMsWordSolid;
export { IconMsWordSolid };